module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.isFileUploadInProgress) ? _c('div', {
    staticClass: "screen screenLoader"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _vm._v(" "), (_vm.confirmationPoupFlag) ? _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "drpPopup"
  }, [_c('div', {
    staticClass: "decisionTitle"
  }, [_c('div', {
    staticClass: "confirmationTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.no_file_txt")))])]), _vm._v(" "), _c('div', {
    staticClass: "drpPopupBtnHolder"
  }, [_c('span', {
    staticClass: "leftBtnPopup",
    on: {
      "click": function($event) {
        return _vm.closeConfirmationPopup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.no_upload_file")))]), _vm._v(" "), _c('span', {
    staticClass: "rightBtnPopup",
    on: {
      "click": function($event) {
        return _vm.moveToMetadataPage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.yes_skip_step")))])])])]) : _vm._e(), _vm._v(" "), (_vm.uploadFileToServerConfirmationPoupFlag) ? _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "drpPopup"
  }, [_c('div', {
    staticClass: "decisionTitle"
  }, [_c('div', {
    staticClass: "confirmationTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.ensure_upload_txt")))])]), _vm._v(" "), _c('div', {
    staticClass: "drpPopupBtnHolder"
  }, [_c('span', {
    staticClass: "leftBtnPopup",
    on: {
      "click": function($event) {
        return _vm.closeUploadConfirmationPopup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.no_review_upload")))]), _vm._v(" "), _c('span', {
    staticClass: "rightBtnPopup",
    on: {
      "click": function($event) {
        return _vm.uploadFiles()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.yes_finish_upload")))])])])]) : _vm._e(), _vm._v(" "), (_vm.discardFilesConfirmationPoupFlag) ? _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "drpPopup"
  }, [_c('div', {
    staticClass: "decisionTitle"
  }, [_c('div', {
    staticClass: "confirmationTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.discard_uploadfile_txt")))])]), _vm._v(" "), _c('div', {
    staticClass: "drpPopupBtnHolder"
  }, [_c('span', {
    staticClass: "leftBtnPopup",
    on: {
      "click": function($event) {
        return _vm.closeDiscardFilePopup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.no_stay_page")))]), _vm._v(" "), _c('span', {
    staticClass: "rightBtnPopup",
    on: {
      "click": function($event) {
        return _vm.moveToLandingPage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_popup.yes_discard_file")))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_c('span', {
    staticClass: "backText",
    class: [{
      'opacity5': _vm.isFileUploadInProgress
    }],
    on: {
      "click": function($event) {
        return _vm.backButtonClick()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" " + _vm._s(_vm.$t("message.front_page.back_btn")))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "centerDiv"
  }, [_c('span', {
    staticClass: "uploadTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.upload_txt")))]), _vm._v(" "), _c('span', {
    staticClass: "metadataTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.metadata_txt")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_c('span', {
    staticClass: "filesAndFoldersTxt"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.upload_file")))]), _vm._v(" "), _c('span', {
    staticClass: "fltRight"
  }, [_c('button', {
    staticClass: "completeTask nextPosition",
    class: [{
      'opacity5': _vm.isFileUploadInProgress
    }],
    on: {
      "click": function($event) {
        return _vm.nextButtonClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.next_btn")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 tp15"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("message.upload_page.filename_note")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 drpAndFilesContainer"
  }, [_c('div', {
    staticClass: "drpHolder",
    class: [{
      'moveLeft': _vm.isFilesUploaded
    }]
  }, [_c('div', {
    staticClass: "dropzone",
    attrs: {
      "id": "drpContainer"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show.visible",
      value: (_vm.isFilesUploaded),
      expression: "isFilesUploaded",
      modifiers: {
        "visible": true
      }
    }],
    attrs: {
      "id": "statusContainer"
    }
  }, [_c('div', {
    staticClass: "uploadText"
  }, [_vm._v(_vm._s(_vm.$t("message.upload_page.uploaded_file")))]), _vm._v(" "), _c('div', {
    staticClass: "dropzone-previews",
    attrs: {
      "id": "previewContainer"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "middleHolder"
  }, [_c('span', {
    staticClass: "completedTask"
  }), _vm._v(" "), _c('span', {
    staticClass: "connectingLine"
  }), _vm._v(" "), _c('span', {
    staticClass: "pendingTask"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7481216"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropzone/DropzoneFormNew.vue
// module id = 167
// module chunks = 1